import React, { useEffect, useState } from 'react'
import { firestore } from '../../../firebase'
import PlayerSelector from './PlayerSelector'
import PlayerSelectorModal from './templates/PlayerSelectorModal'

function AddCoach({ teamId }) {
    const [player, setPlayer] = useState(null)
    const [playerId, setPlayerId] = useState(null)

    const [image, setImage] = useState('')
    const [name, setName] = useState('')
    const [role, setRole] = useState('')
    const [order, setOrder] = useState(0)

    const [error, setError] = useState('')

    async function submitHandler(e) {
        e.preventDefault()
        try {
            const coachRef = firestore
                .collection('teams')
                .doc(teamId)
                .collection('coaches')

            const data = {
                coach_image: image,
                coach_name: name,
                coach_role: role,
                order: order,
            }
            coachRef.add(data)
        } catch (error) {
            setError(error.message)
        }
    }

    useEffect(() => {
        console.log(player)
        if (player && player?.length > 0) {
            setName(player[0].player_name)
            setImage(player[0].player_image)
        } else {
            setName(player?.player_name)
            setImage(player?.player_image)
        }
    }, [player])

    function handleRoleChange(e) {
        setRole(e.target.value)
        if (e.target.value === 'Trener') {
            setOrder(1)
        } else if (e.target.value.includes('Assistent')) {
            setOrder(2)
        } else {
            setOrder(3)
        }
    }

    return (
        <form onSubmit={submitHandler}>
            <label>Navn</label>
            <PlayerSelector
                setPlayer={setPlayer}
                playerId={playerId}
                setPlayerId={setPlayerId}
            />
            <div>
                <PlayerSelectorModal
                    selectedPlayer={player}
                    setSelectedPlayer={setPlayer}
                />
            </div>

            <label>Navn</label>
            <input
                value={name}
                onChange={(e) => setName(e.target.value)}
                className="form-control mb-2"
            />

            <label>Bilde</label>
            <input
                value={image}
                onChange={(e) => setImage(e.target.value)}
                className="form-control mb-2"
            />

            {image && (
                <div className="row">
                    <div className="col-md-4 col-lg-3 col-xl-2">
                        <img src={image} alt="selectedPlayer" />
                    </div>
                </div>
            )}

            <label>Rolle</label>
            <select
                className="browser-default custom-select mb-3"
                onChange={handleRoleChange}
            >
                <option>Velg rolle</option>
                <option value="Trener">Trener</option>
                <option value="Assistenttrener">Assistenttrener</option>
                <option value="Fysio">Fysio</option>
                <option value="Materialforvalter">Materialforvalter</option>
            </select>
            <label>Fyll inn rolle manuelt</label>
            <input
                value={role}
                onChange={(e) => setRole(e.target.value)}
                className="form-control mb-2"
            />

            <label>
                Rekkefølge (Hovedtrener = 1, assistent = 2, resten = 3)
                Gjeldende: {order}
            </label>
            <select
                className="browser-default custom-select"
                onChange={(e) => setOrder(e.target.value)}
            >
                <option>Velg rekkefølge</option>
                <option value={1} selected={order === 1}>
                    1
                </option>
                <option value={2} selected={order === 2}>
                    2
                </option>
                <option value={3} selected={order === 3}>
                    3
                </option>
            </select>

            {error && <div className="alert alert-danger">{error}</div>}
            <button className="btn btn-primary btn-rounded">
                Legg til støtteapparat
            </button>
        </form>
    )
}
export default AddCoach
